export enum MaskType {
    DOCUMENT,
    SELFIE
}